define((require) => {
    "use strict";

    const {find, extend}                = require("underscore");
    const LocalizationGroup             = require("shared/services/localization/LocalizationGroup");
    const DraggableContentThumbnailView = require("ui/publish/DraggableContentThumbnailView");
    const Syncer                        = require("shared/services/sync/Syncer");
    const ImprovedView                  = require("editor/zbone/ImprovedView");
    const ContentQuery                  = require("data/ContentQuery");
    const template                      = require("ui/publish/PublishToolbarThumbnailView.tpl");
    const PublishableCollectionView     = require("ui/publish/PublishableCollectionView");
    const SortingPanel                  = require("ui/common/SortingPanel");

    /**
     * @class PublishToolbarThumbnailView
     */
    return ImprovedView.extend({

        template,

        horizontalScrollBuffer: 220,

        regions: {
            sortingPanelRegion: ".sorting-panel-region",
            content: ".content"
        },

        ui: {
            experienceThumbnails: ".experience-thumbnails"
        },

        initialize() {
            this.collection = this.options.collection;
        },

        onShow() {
            const {
                project,
                collection,
                collectionViewOptions
            } = this.options;

            const publishableCollectionViewOptions = extend({
                collection: this.collection,
                itemView: DraggableContentThumbnailView,
                itemViewOptions: (model) => {
                    // Since most of options are needed, we just return all options for simplicity.
                    return extend(this.options, {
                        localizedGroup: this._getLocalizedGroup(model)
                    });
                },
                horizontalBuffer: this.horizontalScrollBuffer,
                scrollTarget: this.ui.experienceThumbnails
            }, collectionViewOptions || this.collectionViewOptions);

            if (project) {
                this.sortingPanelOptions = extend({}, this.options);

                this.collection.options.project = project;
            }

            this._sortingPanel = new SortingPanel(this.sortingPanelOptions);

            this._collectionView = new PublishableCollectionView(publishableCollectionViewOptions);

            this.sortingPanelRegion.show(this._sortingPanel);
            this.content.show(this._collectionView);

            this.listenTo(this.collection, {
                "sync:state": () => { // only used for fetch
                    this._sortingPanel.disable(!Syncer.State.complete(this.collection));
                }
            });

            const sorting = ContentQuery.sort().field("editedAt");

            this.listenTo(this._sortingPanel, {
                "sort": () => {
                    this.collection.query(sorting);
                },

                "search": (tags) => {
                    this.collection.query(ContentQuery.search(tags, sorting));
                }
            });

            if (project) {
                this.$el.addClass("project-context");
                this.listenTo(this._sortingPanel, "select", (text) => {
                    if (text === SortingPanel.FILTER_ATTRIBUTES.project) {
                        collection.options.project = project;
                    } else {
                        delete collection.options.project;
                    }

                    collection.query(collection.currentQuery());
                });
            }
        },

        _getLocalizedGroup(experience) {
            return find(this.collection.models(), (model) => {
                return (model instanceof LocalizationGroup) && !!model.findAssetById(experience.get("id"));
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/PublishToolbarThumbnailView.js